
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/publishing/collaboration/sharing-settings",
      function () {
        return require("private-next-pages/publishing/collaboration/sharing-settings.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/publishing/collaboration/sharing-settings"])
      });
    }
  